import type { MouseEvent } from 'react'

import { buildCampaignsSteps } from 'actions/mapping.typed'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

import type { Campaign } from '../../types'

import { statusToCN } from '../../const'

const notPropagate = (e: MouseEvent) => e.stopPropagation()

export type SubInfoKeys =
	| 'id'
	| 'state'
	| 'statistics'
	| 'steps'
	| 'target_audience_count'

// TODO: replace `.add-contacts-button-team` into separate component. Combine with `<Button />` component

export function SubInfo({
	id,
	state,
	statistics,
	steps: originalSteps,
	target_audience_count: audienceCount
}: Pick<Campaign, SubInfoKeys>) {
	const steps = buildCampaignsSteps(originalSteps)

	return state !== 'Compose' ? (
		<div className='flex-container-performed-progress-campaigns'>
			<div className='performed-progress-campaigns'>
				<div
					className={clsx('performed-bar', statusToCN[state])}
					style={{
						width: `${
							statistics.started_count && audienceCount
								? (statistics.started_count / audienceCount) * 100
								: '0'
						}%`
					}}
				>
					&nbsp;
				</div>
			</div>

			<div className='performed-bar-value'>
				<div className='performed-bar-text'>{statistics.started_count}</div>
				<div className='performed-bar-text'>{statistics.in_queue_count}</div>
			</div>
		</div>
	) : (
		<div className='flex-container-team-statistics'>
			<div className='contacts-count'>
				{audienceCount ? (
					`Contacts: ${audienceCount}`
				) : (
					<Link
						className='add-contacts-button-team'
						onClick={notPropagate}
						to={`/campaigns/${id}/contacts`}
					>
						Add contacts
					</Link>
				)}
			</div>
			<div>
				{steps.length === 0 ? (
					<Link
						className='add-contacts-button-team'
						onClick={notPropagate}
						to={`/campaigns/${id}/tune`}
					>
						Add actions
					</Link>
				) : (
					<div className='contacts-count'>
						{`${steps[0].name} `}
						{steps.length - 1 > 0 ? `(+${steps.length - 1})` : ''}
					</div>
				)}
			</div>
		</div>
	)
}
